import { gql } from '@apollo/client';
import APP_ACCESS_DETAILS_FRAGMENT from '../fragments/app-access-details';
import APP_PURCHASE_DETAILS_FRAGMENT from '../fragments/app-purchase-details';
import PRODUCT_CURRICULUM_FRAGMENT from '../fragments/product-curriculum';
import PRODUCT_FAMILY_FRAGMENT from '../fragments/product-family';
import PRODUCT_FRAGMENT from '../fragments/product';

const GET_PRODUCT_CACHE = gql`
  query getProductCache {
    products {
      ...BaseProduct
      curriculums {
        ...BaseProductCurriculum
      }
    }
    productFamilies {
      ...BaseProductFamily
      products {
        code
        name
        type
        iconUrl
      }
    }
    apps {
      id
      name
      title
      description
      type
      pliManaged
      products {
        ...BaseProduct
      }
      accessDetails {
        ...BaseAppAccessDetails
      }
      purchaseDetails {
        ...BaseAppPurchaseDetails
      }
      appProducts {
        id
        appId
        productId
        title
        description
        pliManaged
        product {
          ...BaseProduct
        }
        accessDetails {
          ...BaseAppAccessDetails
        }
        purchaseDetails {
          ...BaseAppPurchaseDetails
        }
      }
    }
  }
  ${APP_ACCESS_DETAILS_FRAGMENT}
  ${APP_PURCHASE_DETAILS_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_FAMILY_FRAGMENT}
`;

export default GET_PRODUCT_CACHE;
